<nav mat-tab-nav-bar class="">
  <a
    mat-tab-link
    *ngFor="let tab of tabItems$ | async"
    [routerLink]="[tab.path]"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
    queryParamsHandling="merge"
  >
    {{ tab.label | translate }}
  </a>
</nav>
